import { IUser, UserStatusEnum } from '@monetize/types/app';
import { DEFAULT_PAGER, TDataTablePager } from '@monetize/types/common';
import { useState } from 'react';
import { handleApiErrorToast } from '../api/axios';
import { doGetUsersListByTenantId } from '../api/usersService';

const pager: TDataTablePager = {
  ...DEFAULT_PAGER,
  sortField: 'name',
  sortOrder: 1,
};

const useTeam = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [teamOwner, setTeamOwner] = useState<IUser[]>([]);

  const searchTeamOwners = async (tenantId: string, query: string) => {
    try {
      setLoading(true);
      const result = await doGetUsersListByTenantId(
        tenantId,
        pager,
        {
          name: { contains: query },
          status: UserStatusEnum.ACTIVE,
        },
        { customXTenantId: tenantId },
      );
      setTeamOwner(result.content);
    } catch (error: any) {
      handleApiErrorToast(error, {
        summary: 'Error while fetching team owner',
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    searchTeamOwners,
    teamOwner,
  };
};

export default useTeam;
